import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSvg } from '../Svg';
import { chameleonPresenceIndicator } from './PresenceIndicator.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonPresenceIndicator({ prefix }), chameleonSvg({ prefix }));
}
